import { render, staticRenderFns } from "./MedEx.vue?vue&type=template&id=6e571d01&"
import script from "./MedEx.vue?vue&type=script&lang=js&"
export * from "./MedEx.vue?vue&type=script&lang=js&"
import style0 from "./MedEx.vue?vue&type=style&index=0&id=6e571d01&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports